import { X } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(X);
Icon.displayName = "X";

export { Icon as X };
//# sourceMappingURL=X.js.map
